import { SkyscannerDropsapiV5alphaPricePulse } from '@skyscanner-internal/drops-api-web-http-client';
import { getCulture } from '@web-platform/shared-universal-utils-frontend-localisation';

import { grpcFetchClientWrapper } from '../internals/clients/grpc/grpc';
import { jhaMiddleware } from '../internals/clients/grpc/jhaMiddleware';

type PricePulseRequest = SkyscannerDropsapiV5alphaPricePulse.PricePulseRequest;
type PricePulseResponse = SkyscannerDropsapiV5alphaPricePulse.PricePulseResponse;

const PRICE_PULSE_CLIENT_NAME = 'PRICE_PULSE';

const pricePulseGrpcClient = grpcFetchClientWrapper<PricePulseRequest, PricePulseResponse>(
  SkyscannerDropsapiV5alphaPricePulse.PricePulseService.getPricePulse,
  {
    clientName: PRICE_PULSE_CLIENT_NAME,
    pathPrefix: '/g/drops-api',
    betaInterceptors: [jhaMiddleware],
  },
);

export const pricePulseRequest = ({
  body,
  headers: callerHeaders,
}: {
  body?: PricePulseRequest;
  headers: Record<string, string>;
}) => {
  const { currency, locale, market } = getCulture();

  const headers = {
    ...callerHeaders,
    'X-Skyscanner-Locale': locale,
    'X-Skyscanner-Market': market,
    'X-Skyscanner-Currency': currency,
  };

  return pricePulseGrpcClient({ body, headers });
};
